module.exports = __webpack_public_path__ + "59ef4346197ee2fc12a96b4f7b8e404b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SX.svg
// module id = VK76
// module chunks = 0